import { useState, useRef, useEffect } from "react";
import { Button } from "./ui/button";
import { User, KeyRound, LogOut } from "lucide-react";

export default function CustomUserMenu({ user, onChangePassword, onLogout }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open]);

  const handleAction = (action) => {
    setOpen(false);
    action();
  };

  return (
    <div className="relative" ref={menuRef}>
      <Button 
        variant="ghost" 
        className="flex items-center gap-2 px-2" 
        onClick={() => setOpen(!open)}
        data-testid="user-menu"
      >
        <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
          <User className="w-4 h-4 text-primary" />
        </div>
        <span className="text-sm font-medium hidden sm:inline max-w-[100px] truncate">
          {user?.name || user?.email}
        </span>
      </Button>
      
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 w-48 bg-popover border border-border rounded-md shadow-lg py-1 animate-in fade-in-0 zoom-in-95">
          {/* User info header */}
          <div className="px-3 py-2 border-b border-border">
            <p className="text-sm font-medium truncate">{user?.name}</p>
            <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          </div>
          
          {/* Menu items */}
          <button
            className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-secondary transition-colors text-left"
            onClick={() => handleAction(onChangePassword)}
            data-testid="change-password-btn"
          >
            <KeyRound className="w-4 h-4" />
            Cambia Password
          </button>
          
          <div className="border-t border-border my-1" />
          
          <button
            className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-secondary transition-colors text-left text-destructive"
            onClick={() => handleAction(onLogout)}
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            Esci
          </button>
        </div>
      )}
    </div>
  );
}
